import { Box, Heading } from "grommet";
import React from "react";
import { useUser } from "../account/AccountStore";
import { AliasViewModel, getAliasesForUser } from "../aliases/AliasStore";
import SkeletonWrapper from "../components/SkeletonWrapper";
import UserAliasCard from "../userExperience/UserAliasCard";
import DiscordAliasLink from "./DiscordAliasLink";

const UserDiscordManagement = () => {
    const user = useUser();

    const [loading, setLoading] = React.useState(true);
    const [aliases, setAliases] = React.useState([] as AliasViewModel[]);

    const getAliases = () => {
        return getAliasesForUser(user.id).then((aliases) => {
            setAliases(aliases);
            setLoading(false);
        });
    };

    React.useEffect(() => {
        if (user.resolved) {
            if (user.id) {
                getAliases();
            } else {
                setLoading(false);
            }
        }
    }, [user]);

    return (
        <Box pad="small">
            <SkeletonWrapper loading={loading}>
                <Box align="center" justify="center" gap="small" pad="small">
                    <Heading level={2}>Discord Profile</Heading>
                    {aliases.length > 0 &&
                        aliases.map((alias) => (
                            <UserAliasCard key={alias.id} {...alias}>
                                <Box align="center" justify="center" gap="small" pad="small">
                                    <DiscordAliasLink aliasID={alias.id}></DiscordAliasLink>
                                </Box>
                            </UserAliasCard>
                        ))}
                    {aliases.length === 0 && <DiscordAliasLink aliasID={""}></DiscordAliasLink>}
                </Box>
            </SkeletonWrapper>
        </Box>
    );
};

export default UserDiscordManagement;
